import { ChangeEvent, TableCell, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutBrokerageStatusCodeEvent } from "./autogen/AutogenLayoutBrokerageStatusCodeEvent";
import { StringUtil } from "@mcleod/core";

export class BrokerageStatusCodeEvent extends AutogenLayoutBrokerageStatusCodeEvent {
    tableBrokerageStatusCodeEventOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;

        const textboxPickupDeliveryNumber: Textbox = event.target.findComponentById("textboxPickupOrDeliveryNumber") as Textbox;
        const textboxEventID: Textbox = event.target.findComponentById("textboxEventId") as Textbox;
        textboxPickupDeliveryNumber.visible = StringUtil.equalsIgnoreCase(modelRow.get("pickup_delivery_enabled"), "Y") || textboxEventID.getFirstLookupModelData()?.get("pickup_delivery_enabled") === "Y";
    }

    textboxEventIdOnChange(event: ChangeEvent) {
        const textboxEventID: Textbox = event.target as Textbox;
        const tableCell: TableCell = textboxEventID.parent as TableCell;
        const curRow: TableRow = tableCell.row as TableRow;
        const textboxPickupDelivery = curRow.findComponentById("textboxPickupOrDeliveryNumber") as Textbox;
        const PDEnabled = textboxEventID.getFirstLookupModelData()?.get("pickup_delivery_enabled");
        textboxPickupDelivery.visible = PDEnabled === "Y";
    }
}
